export const RouteConstant = {
  Auth: "/auth/*",
  Login: "/auth/login",
  Register: "/auth/register",
  MerchantRegister: "/auth/register/merchant",
  Captcha: "/auth/captcha",
  AppLink: "/auth/app",
  Landing: "/aaspasshub",
  Admin: "/admin",
  Account: "/admin/account",
  Settings: "/admin/settings",
  DeleteUser: "/admin/deleteAccount",
  User: "/user",
  Posts: "/user/posts",
  AddPost: "/user/addPost",
  Profile: "/user/profile",
  Chat: "/user/chat",
  Message: "/user/message",
  Notification: "/user/notification",
  AddEvent: "/user/addEvent",
  Events: "/user/events",
  AddArticle: "/user/addArticle",
  Articles: "/user/articles",
  Friends: "/user/friends",
  Merchant: "/merchant",
  CreateAdvert: "/merchant/createAdvert",
  Adverts: "/merchant/adverts",
};
